module.exports = __webpack_public_path__ + "static/media/logo_1536.24e738b5.png";